import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import React from 'react';
import { useSelector } from 'react-redux';
import { AngularContext } from 'react-app';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import { getCurrentLecture } from 'redux/selectors/lecture-page';
import { LecturePageMode } from '..';

const ViewResult = (props: { questionSetId?: number }) => {
  const { injectServices } = React.useContext(AngularContext);

  const [
    CurrentUserManager,
    $state,
  ] = injectServices([
    'CurrentUserManager',
    '$state',
  ]);
  const params = useLecturePageParams();
  const currentLecture = useSelector(getCurrentLecture);

  const canViewResult = params?.mode === LecturePageMode.VIEW
    && CurrentUserManager?.isAdmin()
    && currentLecture?.released;

  if (!canViewResult) return null;

  return (
    <div className='view-result d-flex bg-gray-7 py-2 justify-content-center w-100 text-small font-weight-bold'>
      <span className='text-gray-2'>{t.EVALUATIONS.ADMIN_ONLY()}:</span>
      <a
        className='text-primary d-flex align-items-center'
        href={`#!/courses/${$state.params?.catalogId}/analytics/quiz-and-survey/${props.questionSetId}`}
        target='_blank'
        rel='noreferrer'
        aria-labelledby='view-result'
      >
        <NvIcon
          icon='open-external'
          size='xss-smallest'
          className='mr-1 ml-3'
        />
        <span id='view-result'>
          {t.LECTURE_PAGES.COMPONENTS.SURVEY.VIEW_RESULT()}
        </span>
      </a>
    </div>
  );
};

export default ViewResult;

